import { useAuth } from '../hooks/useAuth';
import { useInactivityTimer } from '../../../common/hooks/useInactivityTimer';

/**
 * Component that handles automatic logout after user inactivity
 * Must be rendered inside AuthProvider to access auth context
 */
export const InactivityLogout = () => {
    const auth = useAuth();

    // Auto-logout after 15 minutes of inactivity
    useInactivityTimer({
        timeout: 15 * 60 * 1000, // 5 minutes
        onTimeout: () => {
            if (auth?.tokens) {
                console.log('Auto-logout: User inactive for 5 minutes');
                auth.logout();
            }
        },
        enabled: !!auth?.tokens, // Only enabled when user is logged in
    });

    // This component doesn't render anything
    return null;
};
